import styled from '@emotion/styled';

import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

export const NotificationContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	background: var(--white);
	border: 1px solid var(--border-color);
	width: 100%;
	border-radius: 4px;
	padding: var(--padding-4);

	a {
		text-decoration: none;
	}
`;

export const FilterBar = styled.div`
	border: 1px solid transparent;
	display: flex;
	gap: 2.5rem;
	flex-direction: row;
	justify-content: space-between;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
	}
`;

export const LoadingRow = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-start;
	border-bottom: 1px solid var(--border-color);
	font-size: var(--paragraph3-font-size);
	padding: 1rem;
	margin: 1rem;
	div {
		margin: 0.5rem;
	}
`;

export const NotificationCard = styled(Card)`
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	overflow: unset;

	padding: var(--padding-2);

	border-bottom: 1px solid var(--border-color);

	> div.flex {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		> div.content {
			width: 100%;
		}
	}
	.messageContainer {
		gap: 1.5rem;
	}
	&:hover {
		background-color: rgb(0 0 0 / 7%);
	}
`;

export const BoxIcon = styled.div`
	background-color: ${(props) => props.bgColor};
	color: var(--color-white);
	border-radius: 50%;
	padding: var(--padding-1);
	margin-right: var(--margin-1);
`;

export const MessageHeader = styled.div`
	font-size: var(--paragraph3-font-size);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	margin: var(--margin-2);
`;

export const CardContainer = styled.div`
	display: flex;
	flex-direction: column;
	max-height: calc(100dvh - 32rem);
	overflow: auto;
`;
